import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sms",
  "use": "icon-sms-usage",
  "viewBox": "0 0 1031 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1031 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sms\"><defs><style type=\"text/css\"></style></defs><path d=\"M320 275.2C320 275.2 320 275.2 320 275.2l0 467.2c0 0 0 0 0 0l147.2-128C480 614.4 499.2 608 512 608s32 6.4 44.8 12.8l147.2 128c0 0 0 0 0 0L704 281.6c0 0 0 0 0 0L320 281.6z\" p-id=\"3682\" /><path d=\"M889.6 0 134.4 0C57.6 0 0 57.6 0 134.4l0 761.6C0 966.4 57.6 1024 134.4 1024l761.6 0c70.4 0 134.4-57.6 134.4-134.4L1030.4 134.4C1024 57.6 966.4 0 889.6 0zM768 742.4c0 38.4-32 64-64 64-12.8 0-32-6.4-44.8-19.2L512 672l-147.2 121.6c-25.6 19.2-64 19.2-89.6 0C262.4 780.8 256 761.6 256 742.4L256 281.6c0-38.4 32-64 64-64L704 217.6c38.4 0 64 32 64 64L768 742.4z\" p-id=\"3683\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sms.svg
// module id = AS+9
// module chunks = 188